// "Extract from Text" dialog used by every Precharting tab. It is the Global Paste, opened from the tab you
// are on: text with headings is split into the right sections (whichever tab it is pasted from), and text
// without a heading is read as the section of the current tab.
import React from 'react';
import { ClipboardPaste } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../../ui/dialog';
import { SECTION_LABELS } from '../../../utils/prechartingPasteParser';
import GlobalPasteTab from './global-paste-tab';

/**
 * Props:
 *  - isOpen / onClose
 *  - sectionKey: section of the tab the dialog was opened from (problemList, medicationList, vitalsLabs,
 *      surgicalHistory, hospitalization, diagnosticImaging, procedures, specialistsVisits)
 *  - prechartingData: current chart data of all tabs
 *  - onApply(updates, mode): applies the result to the chart (see GlobalPasteTab)
 */
const GlobalPasteModal = ({ isOpen, onClose, sectionKey, prechartingData, onApply, readonly = false }) => (
  <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
    <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <ClipboardPaste className="h-5 w-5 text-blue-500" />
          Extract from Text — {SECTION_LABELS[sectionKey] || 'Precharting'}
        </DialogTitle>
        {/* Visually hidden, kept for screen readers (dialog accessibility). */}
        <DialogDescription className="sr-only">
          Paste text to add it to the precharting sections.
        </DialogDescription>
      </DialogHeader>
      <GlobalPasteTab
        embedded
        defaultMode="append"
        defaultSectionKey={sectionKey}
        prechartingData={prechartingData}
        onApply={onApply}
        onApplied={onClose}
        readonly={readonly}
      />
    </DialogContent>
  </Dialog>
);

export default GlobalPasteModal;
